<template>
  <Toast />
  <div class="p-grid">
    <div class="p-col-12">
      <Panel header="Gerenciamento de Eventos">
        <Toolbar class="p-mb-4">
          <template #start>
            <Button
              label="Novo"
              icon="pi pi-plus"
              class="mr-2"
              @click="showCreate()"
            />
          </template>
          <template #end> </template>
        </Toolbar>
        <DataTable
          :value="list"
          :lazy="true"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 20, 30]"
          v-model:filters="filters"
          ref="dt"
          class="p-datatable-sm"
          dataKey="id"
          selectionMode="single"
          :totalRecords="totalRecords"
          :loading="loading"
          @page="onPage($event)"
          @filter="onFilter($event)"
          filterDisplay="row"
          responsiveLayout="scroll"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} eventos."
        >
          <template #empty>
            <div class="text-center">Nenhum resultado encontrado...</div>
          </template>
          <!-- <Column field="id" header="#">
            <template #body="slotProps">
              {{ slotProps.data.id }}
            </template>
          </Column> -->
          <Column
            field="id"
            header="Código"
            ref="id"
            filterMatchMode="startsWith"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="number"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="Pesquisar"
                style="min-width: 80px"
              />
            </template>
            <template #body="slotProps">
              <div>{{ slotProps.data.id }}</div>
            </template>
          </Column>
          <Column
            field="local"
            header="Local"
            ref="local"
            filterMatchMode="startsWith"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <Dropdown
                v-model="filterModel.value"
                :options="allLocal"
                optionLabel="name"
                optionValue="id"
                placeholder="Filtrar local"
                @change="filterCallback()"
                :filter="true"
              />
            </template>
            <template #body="slotProps">
              {{ slotProps.data.local.name }}
            </template>
          </Column>
          <Column
            field="name"
            header="Nome"
            ref="name"
            filterMatchMode="startsWith"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="Pesquisar"
              />
            </template>
            <template #body="slotProps">
              <div class="p-text-uppercase">{{ slotProps.data.name }}</div>
            </template>
          </Column>
          <Column
            field="pae"
            header="Pae"
            ref="pae"
            filterMatchMode="startsWith"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="Pesquisar"
              />
            </template>
            <template #body="slotProps">
              {{ slotProps.data.pae }}
            </template>
          </Column>
          <Column
            field="type"
            header="Tipo"
            ref="tipo"
            filterMatchMode="startsWith"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <Dropdown
                v-model="filterModel.value"
                :options="allTypes"
                optionLabel="name"
                optionValue="key"
                placeholder="Filtrar tipo"
                @change="filterCallback()"
                :filter="true"
              />
            </template>
            <template #body="slotProps">
              <span
                :class="
                  'evento-badge status-' + $Util.formatType(slotProps.data.type)
                "
                >{{ $Util.formatType(slotProps.data.type) }}</span
              >
            </template>
          </Column>
          <Column field="dtCreated" header="Data da Solicitação">
            <template #body="slotProps">
              {{ $DateTime.formatarDateTime24hours(slotProps.data.dtCreated) }}
            </template>
          </Column>
          <Column field="dtUpdate" header="Data de Modificação">
            <template #body="slotProps">
              {{ $DateTime.formatarDateTime24hours(slotProps.data.dtUpdate) }}
            </template>
          </Column>
          <Column field="dtEvento" header="Data do Evento" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Data do Evento</span>
              <div v-if="slotProps.data.calendars.length > 0">
                <div
                  v-if="
                    this.$DateTime.formatarDate(
                      slotProps.data.calendars[0].date
                    ) ===
                    this.$DateTime.formatarDate(
                      slotProps.data.calendars[
                        slotProps.data.calendars.length - 1
                      ].date
                    )
                  "
                >
                  {{
                    this.$DateTime.formatarDate(
                      slotProps.data.calendars[0].date
                    )
                  }}
                </div>
                <div v-else>
                  {{
                    this.$DateTime.formatarDate(
                      slotProps.data.calendars[0].date
                    )
                  }}
                  -
                  {{
                    this.$DateTime.formatarDate(
                      slotProps.data.calendars[
                        slotProps.data.calendars.length - 1
                      ].date
                    )
                  }}
                </div>
              </div>
            </template>
          </Column>
          <Column
            field="status"
            header="Status"
            ref="status"
            filterMatchMode="startsWith"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <Dropdown
                v-model="filterModel.value"
                :options="allStatus"
                optionLabel="name"
                optionValue="key"
                placeholder="Filtrar status"
                @change="filterCallback()"
                :filter="true"
              />
            </template>
            <template #body="slotProps">
              <span
                :class="
                  'evento-badge status-' +
                  $Util.formatEventStatus(slotProps.data.status)
                "
                >{{ $Util.formatEventStatus(slotProps.data.status) }}</span
              >
            </template>
          </Column>
          <Column header="Ações">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="editEvent(slotProps.data)"
                v-tooltip.left="'Editar Evento.'"
                v-if="
                  slotProps.data.status === 'REQUESTED' ||
                  slotProps.data.status === 'SCHEDULE'
                "
              />
              <Button
                icon="pi pi-check"
                class="p-button-rounded p-button-info mr-2"
                v-if="slotProps.data.status === 'REQUESTED'"
                v-tooltip.left="'Agendar Evento.'"
                @click="showSchedule(slotProps.data)"
              />
              <Button
                icon="pi pi-times"
                class="p-button-rounded p-button-danger mr-2"
                v-tooltip.left="'Cancelar Evento.'"
                v-if="
                  slotProps.data.status === 'REQUESTED' ||
                  slotProps.data.status === 'SCHEDULE'
                "
                @click="showCancel(slotProps.data)"
              />
              <Button
                icon="pi pi-eye"
                class="p-button-rounded"
                v-tooltip.left="'Detalhes Evento.'"
                @click="showDetails(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>
      </Panel>
    </div>
    <ConfirmDialog></ConfirmDialog>
  </div>

  <dialog-form :eventSelected="obj" @findAll="findAll" />
  <dialog-cancel-vue :objSelected="obj" @findAll="findAll" />
  <dialog-details-vue :objSelected="obj" @findAll="findAll" />
</template>

<script>
//models
import Event from "../../../src/models/internal/event";
import Responsible from "../../../src/models/internal/responsible";
//services
import EventService from "../../../src/service/internal/event/event_service";
import ResponsibleService from "../../../src/service/internal/responsible/responsible_service";
import LocalService from "../../../src/service/internal/local/local_service.js";
//components
import DialogForm from "./components/dialog-form.vue";
import DialogCancelVue from "./components/dialog-cancel.vue";
import DialogDetailsVue from "../calendar/components/dialog-details.vue";
//enums
import { StatusEvent } from "../../models/enums/status_event";
import { TypeEvent } from "../../models/enums/type_event";

export default {
  components: {
    DialogForm,
    DialogDetailsVue,
    DialogCancelVue,
  },
  data() {
    return {
      obj: new Event(),
      personObj: {},
      list: [],
      service: new EventService(),
      filters: {
        id: { value: "", matchMode: "contains" },
        name: { value: "", matchMode: "contains" },
        pae: { value: "", matchMode: "contains" },
        local: { value: "", matchMode: "contains" },
        type: { value: "", matchMode: "contains" },
        status: { value: "", matchMode: "contains" },
      },
      lazyParams: {},
      totalRecords: 0,
      loading: false,
      responsibleService: new ResponsibleService(),
      localService: new LocalService(),
      allStatus: StatusEvent,
      allTypes: TypeEvent,
      allLocal: [],
    };
  },
  mounted() {
    this.lazyParams = {
      first: 0,
      size: this.$refs.dt.rows,
      id: "",
      name: "",
      pae: "",
      local: "",
      type: "",
      status: "",
      sortField: null,
      sortOrder: null,
    };
    this.findAll();
    this.findLocal();
  },
  methods: {
    findAll() {
      this.loading = true;
      //LIMPEZA DE FILTROS
      this.lazyParams.id = this.lazyParams.id == null ? "" : this.lazyParams.id;
      this.lazyParams.name =
        this.lazyParams.name == null ? "" : this.lazyParams.name;
      this.lazyParams.pae =
        this.lazyParams.pae == null ? "" : this.lazyParams.pae;
      this.lazyParams.local =
        this.lazyParams.local == null ? "" : this.lazyParams.local;
      this.lazyParams.type =
        this.lazyParams.type == null ? "" : this.lazyParams.type;
      this.lazyParams.status =
        this.lazyParams.status == null ? "" : this.lazyParams.status;
      // FIM LIMPEZA DE FILTROS
      this.service.findAllEvents(this.lazyParams).then((data) => {
        this.list = data.content;
        this.totalRecords = data.totalElements;
        this.loading = false;
      });
    },
    findLocal() {
      this.localService.findAll().then((data) => {
        this.allLocal = data;
      });
    },
    onPage(event) {
      this.lazyParams.page = event.page;
      this.lazyParams.size = event.rows;
      this.findAll();
    },
    showCreate() {
      this.obj = new Event();
      this.$store.state.views.event.dialogForm = true;
    },
    editEvent(event) {
      this.obj = event;
      this.findResponsibleById(this.obj.responsible.id);
      this.$store.state.views.event.dialogForm = true;
      this.$store.state.views.event.editionMode = true;
    },
    showSchedule(event) {
      this.$confirm.require({
        message: 'Confirma o agendamento do Evento: "' + event.name + '"?',
        header: "Confirmação",
        icon: "pi pi-calendar",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          event.status = "SCHEDULE";
          this.service
            .update(event)
            .then((data) => {
              if (data.status === 200) {
                this.$toast.add({
                  severity: "success",
                  summary: "Alerta!",
                  detail: "Evento agendado com sucesso.",
                  life: 3000,
                });
                this.findAll();
              }
            })
            .catch((error) => {
              this.findAll();
              this.$msgErro(error);
            });
        },
      });
    },

    scheduleEvent(event) {
      event.status = "SCHEDULE";
      this.service
        .update(event)
        .then((data) => {
          if (data.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "Alerta!",
              detail: "Evento agendado com sucesso.",
              life: 3000,
            });
            this.findAll();
          }
        })
        .catch((error) => {
          this.findAll();
          this.$msgErro(error);
        });
    },
    showCancel(event) {
      this.obj = event;
      this.$store.state.views.event.dialogCancel = true;
    },
    showDetails(event) {
      this.obj = event;
      this.findPerson();
      this.$store.state.views.event.dialogDetails = true;
    },
    findPerson() {
      this.responsibleService.findById(this.obj.responsible.id).then((res) => {
        this.obj.responsible = new Responsible(res);
      });
    },
    onFilter() {
      this.lazyParams.page = 0;
      this.lazyParams.id = this.filters.id.value
        ? parseInt(this.filters.id.value, 10)
        : null;
      this.lazyParams.name = this.filters.name.value;
      this.lazyParams.pae = this.filters.pae.value;
      this.lazyParams.local = this.filters.local.value;
      this.lazyParams.type = this.filters.type.value;
      this.lazyParams.status = this.filters.status.value;
      this.findAll();
    },

    //ESSE MÉTODO É IDENTICO A UM OUTRO QUE JÁ EXISTE, FUTURAMENTE VERIFICAR A NECESSIDADE DE AMBOS E ADEQUAR FOI CRIADO SOMENTE PARA CORRIGIR UM BUG AO PASSAR O OBJETO.
    findResponsibleById(id) {
      this.responsibleService.findById(id).then((data) => {
        this.obj.responsible = {
          id: data.id,
          name: data.name,
          status: data.status,
          email: data.email,
          person: data.person,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
